import React from 'react';
import {
  Grid,
  IconButton,
  Button,
  makeStyles,
  colors,
} from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';

import useIsUpMD from 'hooks/media_query/useIsUpMD';

import Title from 'components/typography/Title';

const useStyles = makeStyles({
  button: {
    color: colors.red[400],
    '&:hover': {
      backgroundColor: colors.red[100],
    },
  },
  submitButton: {
    backgroundColor: colors.red[400],
    color: colors.grey[50],
    '&:hover': {
      backgroundColor: colors.red[100],
    },
  },
  title: {
    color: colors.red[400],
  },
});

const Step = ({
  onBackButtonClick,
  onNextButtonClick,
  renderDescription,
  renderBody,
  nextStepLabel = 'NEXT STEP',
  stepTitle,
  headerButtons,
  spacing = 5,
  fullWidthBody = false,
  headerStyle = { marginLeft: -16 },
}) => {
  const isUpMD = useIsUpMD();
  const classes = useStyles();

  return (
    <Grid container direction="column" alignItems="center">
      <Grid
        item
        container
        justify="flex-start"
        alignItems="center"
        spacing={isUpMD ? 4 : 1}
      >
        <Grid item style={headerStyle}>
          <IconButton onClick={onBackButtonClick} className={classes.button}>
            <ArrowBack></ArrowBack>
          </IconButton>
        </Grid>
        <Grid item style={{ flexGrow: 1 }}>
          <Title variant={isUpMD ? 'h4' : 'h5'}>
            <span className={classes.title}>{stepTitle}</span>
          </Title>
        </Grid>
        {headerButtons && <Grid item>{headerButtons}</Grid>}
      </Grid>

      <Grid
        item
        container
        direction="column"
        style={{ marginTop: spacing * 8 }}
        md={fullWidthBody ? 12 : 8}
      >
        {renderDescription && (
          <Grid item container>
            {renderDescription()}
          </Grid>
        )}
        {renderBody && (
          <Grid
            item
            container
            style={{ marginTop: renderDescription ? 32 : 0 }}
          >
            {renderBody()}
          </Grid>
        )}
        {onNextButtonClick && (
          <Grid
            item
            container
            justify="flex-end"
            style={{ marginTop: renderDescription || renderBody ? 32 : 0 }}
          >
            <Button
              onClick={onNextButtonClick}
              className={classes.submitButton}
            >
              <b>{nextStepLabel}</b>
            </Button>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default Step;
